import { useCallback, useEffect, useRef, useState } from "react";
import {
  ActionBtnDots,
  AddIcon,
  BardanaDashboardIcon,
  CashTotalDashboardIcon,
  CollectionTotalDashboardIcon,
  CommTotalDashboardIcon,
  DashboardGridArrow,
  DeleteModalIcon,
  RupeeIcon,
  SaleTotalDashboardIcon,
  SearchIcon,
} from "../../assets/svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearCredentials, setCredentials } from "../../authSlice";
import toast from "react-hot-toast";

const DashboardLandingPage = () => {
  const { token, username } = useSelector((state) => state.auth);
  const [totalSalesToday, setTotalSalesToday] = useState([]);
  const [tokenExpired, setTokenExpired] = useState(false);
  const [totalCommissionToday, setTotalCommissionToday] = useState([]);
  const [totalCashSalesToday, setTotalCashSalesToday] = useState([]);
  const [totalCashSalesByAdminToday, setTotalCashSalesByAdminToday] = useState(
    []
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError(null);
      try {
        const salesData = await getSalesToday(token, dispatch, setTokenExpired);
        const commissionData = await getCommissionToday(
          token,
          dispatch,
          setTokenExpired
        );
        const cashSalesData = await getCashSalesToday(
          token,
          dispatch,
          setTokenExpired
        );
        const cashSaleAdminData = await getCashSalesByADmin(
          token,
          dispatch,
          setTokenExpired
        );
        setTotalSalesToday(salesData);
        setTotalCommissionToday(commissionData);
        setTotalCashSalesToday(cashSalesData);
        setTotalCashSalesByAdminToday(cashSaleAdminData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (tokenExpired) {
      dispatch(clearCredentials());
      return;
    }
    if (!token || token === "null") {
      setError("No token available. Please log in.");
      setLoading(false);
      return;
    } else {
      fetchUsers();
    }
  }, [dispatch, token, tokenExpired]);
  if (error) return <div>Error: {error}</div>;
  return (
    <>
      <div className="whiteBgDiv dashboardPadding">
        <div className="mainHeading">Dashboard</div>
        <div className="dasboardGridBox">
          <div
            className="gridBox"
            style={{
              border: "1px solid #E1C10A",
              background: "rgba(225, 193, 10, 0.08)",
            }}
          >
            <span>
              <BardanaDashboardIcon />
            </span>
            <div className="textContent">
              {loading ? "..." : 56}
              <div className="flexBox">
                <p>Total Pending Bardanas for collection.</p>
                <div className="svgArrow">
                  <DashboardGridArrow />
                </div>
              </div>
            </div>
          </div>
          <div
            className="gridBox"
            style={{
              border: "1px solid #00A65A",
              background: "rgba(0, 166, 90, 0.08)",
            }}
          >
            <span>
              <SaleTotalDashboardIcon />
            </span>
            <div className="textContent">
              {loading ? (
                "..."
              ) : (
                <>
                  <RupeeIcon />
                  {totalSalesToday.combinedGrandTotal}
                </>
              )}
              <div className="flexBox">
                <p>Total sale today (excluding comm.)</p>
                <div className="svgArrow">
                  <DashboardGridArrow />
                </div>
              </div>
            </div>
          </div>
          <div
            className="gridBox"
            style={{
              border: "1px solid #0575E6",
              background: "rgba(5, 117, 230, 0.08)",
            }}
          >
            <span>
              <CollectionTotalDashboardIcon />{" "}
            </span>
            <div className="textContent">
              {loading ? (
                "..."
              ) : (
                <>
                  <RupeeIcon />
                  56
                </>
              )}
              <div className="flexBox">
                <p>Total collection today</p>
                <div className="svgArrow">
                  <DashboardGridArrow />
                </div>
              </div>
            </div>
          </div>
          <div
            className="gridBox"
            style={{
              border: "1px solid rgba(221, 75, 57, 0.64)",
              background: "rgba(221, 75, 57, 0.08)",
            }}
          >
            <span>
              <CommTotalDashboardIcon />{" "}
            </span>
            <div className="textContent">
              {loading ? (
                "..."
              ) : (
                <>
                  <RupeeIcon />
                  {totalCommissionToday.totalCommission}
                </>
              )}
              <div className="flexBox">
                <p>Total comm.today (incl. Nugs)</p>
                <div className="svgArrow">
                  <DashboardGridArrow />
                </div>
              </div>
            </div>
          </div>
          <div
            className="gridBox"
            style={{
              border: "1px solid #E1C10A",
              background: "rgba(225, 193, 10, 0.08)",
            }}
          >
            <span>
              <CashTotalDashboardIcon />{" "}
            </span>
            <div className="textContent">
              {loading ? (
                "..."
              ) : (
                <>
                  <RupeeIcon />
                  {totalCashSalesToday.totalSales}
                </>
              )}
              <div className="flexBox">
                <p>Total cash sale today.</p>
                <div className="svgArrow">
                  <DashboardGridArrow />
                </div>
              </div>
            </div>
          </div>
          <div
            className="gridBox"
            style={{
              border: "1px solid #00A65A",
              background: "rgba(0, 166, 90, 0.08)",
            }}
          >
            <span>
              <CashTotalDashboardIcon />{" "}
            </span>
            <div className="textContent">
              {loading ? (
                "..."
              ) : (
                <>
                  <RupeeIcon />
                  {totalCashSalesByAdminToday.totalSales}
                </>
              )}
              <div className="flexBox">
                <p>
                  Total cash sale today. (by{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {username}
                  </span>
                  )
                </p>
                <div className="svgArrow">
                  <DashboardGridArrow />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="whiteBgDiv dashboardTablePadding">
        <UserList />
      </div>
    </>
  );
};

export default DashboardLandingPage;

const getSalesToday = async (token, dispatch, setTokenExpired) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/sales/getSalesToday`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401) {
      setTokenExpired(true);
      return;
    }

    if (!response.ok) {
      throw new Error("Failed to get sales");
    }

    const newAccessToken = response.headers.get("Authorization");
    if (newAccessToken) {
      dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching sales:", error);
    throw error;
  }
};
const getCommissionToday = async (token, dispatch, setTokenExpired) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/sales/getCommissionToday`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401) {
      setTokenExpired(true);
      return;
    }

    if (!response.ok) {
      throw new Error("Failed to get Commissions");
    }
    const newAccessToken = response.headers.get("Authorization");
    if (newAccessToken) {
      dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Commissions:", error);
    throw error;
  }
};
const getCashSalesToday = async (token, dispatch, setTokenExpired) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/sales/getCashSalesToday`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401) {
      setTokenExpired(true);
      return;
    }

    if (!response.ok) {
      throw new Error("Failed to get Cash Sales");
    }
    const newAccessToken = response.headers.get("Authorization");
    if (newAccessToken) {
      dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Cash Sales:", error);
    throw error;
  }
};
const getCashSalesByADmin = async (token, dispatch, setTokenExpired) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/sales/getAdminCashSalesToday`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401) {
      setTokenExpired(true);
      return;
    }

    if (!response.ok) {
      throw new Error("Failed to get Cash Sales");
    }
    const newAccessToken = response.headers.get("Authorization");
    if (newAccessToken) {
      dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Cash Sales:", error);
    throw error;
  }
};

function UserList() {
  const { token } = useSelector((state) => state.auth);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openRowIndex, setOpenRowIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [currentSearchPage, setCurrentSearchPage] = useState(1);
  const [totalSearchPage, setTotalSearchPage] = useState(1);
  const dropdownRef = useRef(null);
  const [showSearchPagination, setShowSearchPagination] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAddUserLink = () => {
    navigate("/dashboard/user-management");
  };

  const handleEditUserLink = (id) => {
    navigate(`/dashboard/user-management/${id}`);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleDeleteUser = (id) => {
    setShowModal(true);
    setDeleteUserId(id);
  };

  const toggleDropdown = (index) => {
    setOpenRowIndex(openRowIndex === index ? null : index);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenRowIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchUsers = useCallback(
    async (page) => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/getUsers?page=${page}&limit=10`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 401) {
          return;
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          const userData = await response.json();
          setShowSearchPagination(false);
          setUsers(userData.users);
          setCurrentPage(userData.page);
          setTotalPage(userData.totalPages);
        } else {
          setError("Failed to load users");
        }
      } catch (err) {
        setError("Error fetching users");
      } finally {
        setLoading(false);
      }
    },
    [dispatch, token]
  );

  const searchUsers = useCallback(async (page) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/auth/getUsers?page=${page}&limit=10&search=${searchQuery.toLowerCase()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        dispatch(clearCredentials());
        return;
      }

      if (response.ok) {
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }
        const userData = await response.json();
        setShowSearchPagination(true);
        setUsers(userData.users);
        setCurrentSearchPage(userData.page);
        setTotalPage(userData.totalPages);
        setTotalSearchPage(userData.totalPages)
      } else {
        setError("Failed to load users");
      }
    } catch (err) {
      setError("Error fetching users");
    } finally {
      setLoading(false);
    }
  }, [dispatch, searchQuery, token]);

  useEffect(() => {
    if (!token || token === "null") {
      dispatch(clearCredentials());
      navigate("/login");
      setError("No token available. Please log in.");
      setLoading(false);
    } else {
      fetchUsers(currentPage);
      searchUsers(currentSearchPage)
    }
  }, [token, fetchUsers, navigate, currentPage, dispatch, currentSearchPage, searchUsers]);

  const onConfirmDelete = async () => {
    if (!deleteUserId) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/deleteUser?id=${deleteUserId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        dispatch(clearCredentials());
      }

      if (response.ok) {
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }
        toast.success("User deleted successfully", {
          style: {
            border: "1px solid #021F7E",
            padding: "16px",
            color: "#0573E3",
          },
          iconTheme: {
            primary: "#021F7E",
            secondary: "#0573E3",
          },
        });
        console.log("User deleted successfully", response);
        fetchUsers();
      } else {
        const userData = await response.json();
        toast.error(userData.message, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#FE000099",
          },
          duration: 6000,
        });
      }
    } catch (error) {
      toast.error("Failed to delete User", {
        style: {
          border: "1px solid #FE0000",
          padding: "16px",
          color: "#FE0000",
        },
        iconTheme: {
          primary: "#FE0000",
          secondary: "#FE000099",
        },
      });
      console.error("Error deleting user:", error);
    } finally {
      setShowModal(false);
      setDeleteUserId(undefined);
    }
  };

  // const filteredUsers = users.filter(
  //   (user) =>
  //     user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //     (user.email &&
  //       user.email.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //     (user.mobile &&
  //       user.mobile.toLowerCase().includes(searchQuery.toLowerCase()))
  // );

  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center gap-2">
        <div className="mainHeading">Users List</div>
        <div className="d-flex align-items-center" style={{ gap: "9px" }}>
          <div className="searchBox">
            <span
              onClick={() => {
                if (searchQuery !== "") {
                  searchUsers(currentSearchPage);
                } else {
                  fetchUsers(currentPage);
                }
              }}
            >
              <SearchIcon />
            </span>
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchUsers(currentSearchPage);
                }
              }}
            />
          </div>
          <button className="colorBtn addNewBtn" onClick={handleAddUserLink}>
            <AddIcon />
            <span>Add New</span>
          </button>
        </div>
      </div>
      <div className="tableDiv">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Mobile Number</th>
              <th scope="col">Role</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          {!loading ? (
            <tbody>
              {users.length !== 0 ? (
                users.map((user, i) => {
                  const isLast = users.length >= 2 && users.length - 2 <= i;
                  return (
                    <tr key={user._id}>
                      <th scope="row">
                        {((showSearchPagination
                          ? currentSearchPage
                          : currentPage) -
                          1) *
                          10 +
                          i +
                          1}
                      </th>
                      <td>{user.name} </td>
                      <td>{user?.email ? user.email : "-"}</td>
                      <td>{user?.mobile ? user.mobile : "-"}</td>
                      <td>{user.role}</td>
                      {user.role !== "zimindar" && !user.isDeletable ? (
                        <td>
                          <div className="actionDropDown">
                            <span onClick={() => toggleDropdown(i)}>
                              <ActionBtnDots />
                            </span>
                            {openRowIndex === i && (
                              <div
                                className={`dropDownDiv ${
                                  isLast ? "bottom100" : ""
                                }`}
                                ref={dropdownRef}
                              >
                                {user.role !== "zimindar" &&
                                  !user.isDeletable && (
                                    <button
                                      className="delBtn"
                                      onClick={() => handleDeleteUser(user._id)}
                                    >
                                      Delete
                                    </button>
                                  )}
                                <button
                                  className="editBtn"
                                  onClick={() => handleEditUserLink(user._id)}
                                >
                                  <span>Edit</span>
                                </button>
                              </div>
                            )}
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div className="actionDropDown">
                            <button
                              className="editBtn"
                              onClick={() => handleEditUserLink(user._id)}
                            >
                              <span>Edit</span>
                            </button>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <th colSpan={6} scope="row">
                    No User Found
                  </th>
                </tr>
              )}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <th colSpan={6} scope="row">
                  Loading ...
                </th>
              </tr>
            </tbody>
          )}
        </table>
        {totalPage > 1 && (
          <div className="d-flex gap-1 justify-content-end">
            {!showSearchPagination ? (
              <div className="tablePaginationBtnFlex">
                {currentPage > 1 && (
                  <button
                    className="grayBtn"
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Back
                  </button>
                )}
                {totalPage !== currentPage && (
                  <button
                    className="colorBtn"
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>
                )}
              </div>
            ) : (
              <div className="tablePaginationBtnFlex">
                {currentSearchPage > 1 && (
                  <button
                    className="grayBtn"
                    onClick={() => setCurrentSearchPage(currentSearchPage - 1)}
                  >
                    Back
                  </button>
                )}
                {totalSearchPage !== currentSearchPage && (
                  <button
                    className="colorBtn"
                    onClick={() => setCurrentSearchPage(currentSearchPage + 1)}
                  >
                    Next
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {showModal && (
        <div className="modalBackdrop">
          <div className="modalContent">
            <div className="delIcon">
              <DeleteModalIcon />{" "}
            </div>
            <p>Are you sure you want to delete this user?</p>
            <div className="modalActions">
              <button className="colorBtn" onClick={onConfirmDelete}>
                Delete
              </button>
              <button className="grayBtn" onClick={() => setShowModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
